// extracted by mini-css-extract-plugin
export default {"report__container":"styles_report__container__q61W3"};